import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { NewPmeComponent } from '../../new-pme.component';
import Swal from 'sweetalert2';
import { NewPlanMejoraService } from 'src/app/service/newPlanMejora.service';
import { AniosPMEModel, DimensionesAnualPMEModel, NewFaseAnual, ResponseNewFaseAnual } from 'src/app/model/NewFaseAnual.model';


@Component({
  selector: 'app-pme-fase-anual',
  templateUrl: './pme-fase-anual.component.html',
  styleUrls: ['./pme-fase-anual.component.css']
})
export class PmeFaseAnualComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner: ElementRef;
  @Input() simulacion: boolean;
  cargando: boolean;
  cambios: boolean;
  fechaValida: boolean;
  dataJardin = new JardinModel();
  faseAnualData = new NewFaseAnual();
  click = false;

  constructor(
    @Inject(NewPmeComponent) private parent: NewPmeComponent,
    private api: apiService,
    private newPlanMejoraService: NewPlanMejoraService
    ) {}

  ngOnInit(): void {
    this.click = false;
    this.cargando = true;
    this.cambios = false;
    this.fechaValida = true;
    this.cargaInicial();
  }

  change() {
    this.cambios = true;
  }

  cargaInicial() {
    this.dataJardin = this.api.dataJardin;
    this.getFaseAnual(this.dataJardin);
  }

  getFaseAnual(dataJardin: JardinModel) {
    console.log(dataJardin);
    this.newPlanMejoraService.API_GET_getFaseAnual(dataJardin.idJardinPeriodo).subscribe((response: ResponseNewFaseAnual) => {
      this.faseAnualData = response.payload;
      this.cargando = false;
    },
      (err) => {
        console.log(err)
      });
  }

  guardarFaseAnual(anio: AniosPMEModel) {

          Swal.fire({
            title: "Loading...",
            html: "Guardando Avances"
          });
          Swal.showLoading();

    this.newPlanMejoraService.API_POST_guardarFaseAnual(this.dataJardin.idJardinPeriodo, anio).subscribe((response: any) => {
          this.cambios = false;
          this.ngOnInit();
          Swal.fire({
            title: 'Realizado!',
            text: 'Guardado con éxito',
            icon: 'info',
            confirmButtonText: 'OK'
          })
        },
          (err) => {
            console.log(err)
          });
  }



  finalizarAnioFaseAnual(anioData: AniosPMEModel) {
    this.newPlanMejoraService.API_POST_finalizarFaseAnual(this.dataJardin.idJardinPeriodo, anioData).subscribe((response: any) => {
      this.irAFinalizar();
    },
      (err) => {
        console.log(err)
      });
  }

  validarFinalizar(anioData: AniosPMEModel) {
    let errores = [];
    let erroresSinDup = [];
    Swal.fire({
      title: 'Este proceso no se puede deshacer, ¿Desea continuar?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {


              Swal.fire({
                title: "Loading...",
                html: "Finalizando"
              });
              Swal.showLoading();

        anioData.dimensiones.forEach(dimension => {

          if (this.validarDimension1(dimension) != "") {
            errores.push(this.validarDimension1(dimension));

          }
          if (this.validarFechasDimension1(dimension) != "") {
              errores.push(this.validarFechasDimension1(dimension));
          }

          if (this.validarDimension2(dimension) != "") {
            errores.push(this.validarDimension2(dimension));
          }else{

          }


        });


        if (errores.length > 0) {

          erroresSinDup =this.removeDuplicados(errores);

          Swal.fire({
            title: 'Errores de Validación',
            text: erroresSinDup.toString(),
            icon: 'error',
            confirmButtonText: 'OK'
          });
        } else {
         /* this.newPlanMejoraService.API_POST_guardarFaseAnual(this.dataJardin.idJardinPeriodo, anioData).subscribe((response: any) => {

          },
          (err) => {
            console.log(err)
          });*/
          this.finalizarAnioFaseAnual(anioData);
        }
      }
    })
  }

  validarDimension1(dimension: DimensionesAnualPMEModel): string {
    let error = ""
    let count = 0;
    let count2 = 0;
    dimension.subdimensiones.forEach(subd => {
      subd.faseAnual
      
      if(!this.campoVacio(subd.faseAnual.estrategia1) && !this.campoVacio(subd.faseAnual.indicador1e1) && !this.campoVacio(subd.faseAnual.indicador2e1)
        && !this.campoVacio(subd.faseAnual.accion1e1) && !this.campoVacio(subd.faseAnual.accion2e1) && !this.campoVacio(subd.faseAnual.responsable1e1)
        && !this.campoVacio(subd.faseAnual.responsable2e1) && !this.campoVacio(subd.faseAnual.recurso1e1) && !this.campoVacio(subd.faseAnual.recurso2e1)
        &&  !((subd.faseAnual.fechaDesde1e1 == null && subd.faseAnual.fechaHasta1e1 == null) || (subd.faseAnual.fechaDesde2e1 == null && subd.faseAnual.fechaHasta2e1 == null) ||  
        (subd.faseAnual.fechaDesde1e1 == undefined && subd.faseAnual.fechaHasta1e1 == undefined) || (subd.faseAnual.fechaDesde2e1 == undefined && subd.faseAnual.fechaHasta2e1 == undefined)) ){
        count++;
      } else {
        count2++;
       // error = "Debe completar todos los datos de la estrategia 1 de cada subdimensión";
      }
    });

    if (count2 > 0 ) {
      error = "Debe completar todos los datos de la estrategia 1 de cada subdimensión ";
    }

    return error;
  }

  validarDimension2(dimension: DimensionesAnualPMEModel): string {
    let error = ""
    let count = 0;
    let count2 = 0;
    dimension.subdimensiones.forEach(subd => {
      subd.faseAnual
      
      if(!this.campoVacio(subd.faseAnual.estrategia2) && !this.campoVacio(subd.faseAnual.indicador1e2) && !this.campoVacio(subd.faseAnual.indicador2e2)
        && !this.campoVacio(subd.faseAnual.accion1e2) && !this.campoVacio(subd.faseAnual.accion2e2) && !this.campoVacio(subd.faseAnual.responsable1e2)
        && !this.campoVacio(subd.faseAnual.responsable2e2) && !this.campoVacio(subd.faseAnual.recurso1e2) && !this.campoVacio(subd.faseAnual.recurso2e2)
        &&  !((subd.faseAnual.fechaDesde1e2 == null && subd.faseAnual.fechaHasta1e2 == null) || (subd.faseAnual.fechaDesde2e2 == null && subd.faseAnual.fechaHasta2e2 == null) ||  
        (subd.faseAnual.fechaDesde1e2 == undefined && subd.faseAnual.fechaHasta1e2 == undefined) || (subd.faseAnual.fechaDesde2e2 == undefined && subd.faseAnual.fechaHasta2e2 == undefined)) ){
            count++;
            error = this.validarFechasFinalizar(subd.faseAnual.fechaDesde1e2,subd.faseAnual.fechaHasta1e2);
            if(error === ""){
              error = this.validarFechasFinalizar(subd.faseAnual.fechaDesde2e2,subd.faseAnual.fechaHasta2e2);
            }else{
              error = error +" - "+this.validarFechasFinalizar(subd.faseAnual.fechaDesde2e2,subd.faseAnual.fechaHasta2e2);
            }
      } else {

        if(this.campoVacio(subd.faseAnual.estrategia2) && this.campoVacio(subd.faseAnual.indicador1e2) && this.campoVacio(subd.faseAnual.indicador2e2)
          && this.campoVacio(subd.faseAnual.accion1e2) && this.campoVacio(subd.faseAnual.accion2e2) && this.campoVacio(subd.faseAnual.responsable1e2)
          && this.campoVacio(subd.faseAnual.responsable2e2) && this.campoVacio(subd.faseAnual.recurso1e2) && this.campoVacio(subd.faseAnual.recurso2e2)
          &&  ((subd.faseAnual.fechaDesde1e2 == null && subd.faseAnual.fechaHasta1e2 == null) && (subd.faseAnual.fechaDesde2e2 == null && subd.faseAnual.fechaHasta2e2 == null) ||  
          (subd.faseAnual.fechaDesde1e2 == undefined && subd.faseAnual.fechaHasta1e2 == undefined) && (subd.faseAnual.fechaDesde2e2 == undefined && subd.faseAnual.fechaHasta2e2 == undefined)) ){
            count++;
        } else{
          count2++;
        }
      }

    });

    if (count2 > 0 ) {
      error = error +" - "+"Debe completar todos los datos o ninguno de cada estrategia 2 de cada dimension";
    }
    return error;
  }

  validarFechasDimension1(dimension: DimensionesAnualPMEModel): string {
    let error = "";
    dimension.subdimensiones.forEach(subd => {
      subd.faseAnual

      error = this.validarFechasFinalizar(subd.faseAnual.fechaDesde1e1,subd.faseAnual.fechaHasta1e1);

      if(error === ''){
        error = this.validarFechasFinalizar(subd.faseAnual.fechaDesde2e1,subd.faseAnual.fechaHasta2e1);
      }

     /*if(!this.validarFechasFinalizar(subd.faseAnual.fechaDesde1e2,subd.faseAnual.fechaHasta1e2)){
      error = "La fecha hasta no puede ser anterior a la fecha desde";
     }

     if(!this.validarFechasFinalizar(subd.faseAnual.fechaDesde2e2,subd.faseAnual.fechaHasta2e2)){
      error = "La fecha hasta no puede ser anterior a la fecha desde";
     }*/

    });

    return error;
  }


  
  validarFechasFinalizar(fechaInicio: Date, fechaFin: Date) {
    let error = '';

    if (fechaInicio != undefined && fechaFin != undefined && fechaInicio != null && fechaFin != null) {

      fechaInicio = new Date(fechaInicio);
      fechaFin = new Date(fechaFin);

      if (fechaFin.getTime() - fechaInicio.getTime() >= 0) {
        error = '';
      } else {
        error = "La fecha Hasta no puede ser anterior a la fecha Desde";
      }

    } else {
      error = "Faltan fechas por completar";
    }

    return error;
  }

  validarFechas(fechaInicio: Date, fechaFin: Date) {
    let fechaValida = false;

    if (fechaInicio != undefined && fechaFin != undefined && fechaInicio != null && fechaFin != null) {

      fechaInicio = new Date(fechaInicio);
      fechaFin = new Date(fechaFin);

      if (fechaFin.getTime() - fechaInicio.getTime() >= 0) {
        fechaValida = true;
      } else {
        fechaValida = false;
      }

    } else {
      fechaValida = false;
    }
    return fechaValida;
  }

  campoVacio(campo: string): boolean {
    return (campo == null || campo == "") ? true : false;

  }

  irA() {
    this.ngOnInit();
    this.getPlanMejora();
    this.parent.componente="";
    //window.location.reload();
    //this.parent.menuVisible("new-planmejora");
  }


  irAFinalizar() {
    Swal.fire({
      title: 'Fase anual finalizada con éxito',
      icon: 'success',
      confirmButtonText: 'OK'

    }).then(() => {
      this.irA();
    })
  }

  volver() {
    this.irA();
  }

  removeDuplicados(array: string[]): string[]{

    let unique: string[] = [];
    array.forEach(element => {
        if (!unique.includes(element)) {
            unique.push(element);
        }
    });
    return unique;
  }

  getPlanMejora(){
    this.newPlanMejoraService.API_GET_getNewPlanMejora(this.dataJardin.idJardinPeriodo).subscribe((response: any) => {
      this.parent.pme = response.payload;  
    },
    (err) => {
      console.log(err)
    });      
  }

  

}
